export default __webpack_public_path__ + "static/media/dummyRequest.45fcd65b.jpeg";